import React, { useState } from 'react'
import {Container, Row, Col, Table } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import DeliveryCar from '../assets/images/delivery-car.png'
import ProductService from '../services/Product'

const SingleProduct = ({prodId, categoryId, onClickWishList,productName,shortDesc,price,tdsTxt,getTxt,productImage,heart,onClick,passedObject,onClickCart, mrp_in_point, onPressHeart=()=>{}, prodInfo}) => {
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [loadingDetails, setLoadingDetails] = useState(false)
    const [isOverview, setIsOverview] = useState(true)
    const [isSpecification, setIsSpecification] = useState(false)
    const [productDetailsData, setProductDetailsData] = useState({})
    const [productAttributes, setProductAttributes] = useState([])

    const handleTabClick = (tabName) => {
        setIsOverview(tabName === 'overview')
        setIsSpecification(tabName === 'specification')
    }

    const handleViewDetailsClick = async () => {
        setShowDetailsModal(true)
        setIsOverview(true)
        setIsSpecification(false)
        setLoadingDetails(true)
        try {
            const res = await ProductService.productDetailsWeb(prodId, categoryId)
            if (!res.error && res.data?.length > 0) {
                setProductDetailsData(res.data[0])
                setProductAttributes(res.data[0].product_attributes || [])
            }
        }
        catch (error) {
            console.error("Product Details Fetch")
        }
        setLoadingDetails(false)
    }
    return (
        <>
            <div className="itemProductWrap">
                
                <div className="itemWrapImage">
                    <div className='wishListIcon' onClick={() => onPressHeart(prodId)}>
                      <img src={heart} alt='wishList'  className='wishListIconImg'/>
                    </div>
                    <div className='productImageBlock'>
                         <img src={productImage} alt={productName}/>
                    </div>
                     
                </div>
                <div className="itemWrapImageTxt">
                    <p className='titleTxt'>{productName}</p>
                    <p className='descTxt'>{shortDesc}</p>
                    <p className='pointsTxt'>{price} <span>Points *</span></p>
                    <p style={{color: "#343434", fontSize: '15px', minHeight: '1.2em'}}>
                        {(mrp_in_point && mrp_in_point != 0) ? `(${prodInfo?.mrpLabel} : ${mrp_in_point})` : ' '}
                    </p>
                    <p className='tdsApplyTxt'>{tdsTxt}</p>
                    <p className='getItTxt'><img src = {DeliveryCar} alt='deliveryCar'/> {getTxt}</p>
                    <p className='additionalInfoTxt'>{passedObject}</p>
                    {prodInfo?.canRedeem == 1 && <Row className='btnWrap align-items-center'>
                        <Col xs={12} xxl={12} >
                            <div className='ad-btn-2 ad-gap-10'>
                            <PrimaryGradientButton className='primaryBtn undefined btn btn-primary' buttonText="Add To Cart"
                            onClick={onClickCart} />
                            <span className='viewDetailsLink' onClick={handleViewDetailsClick}>View Details</span>
                            </div>

                        </Col>
                    </Row>}

                </div>
            </div>

            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='modalTitleClamp'>{productName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='productImageBlock text-center mb-3'>
                        <img src={productImage} alt={productName} className='img-fluid' />
                    </div>
                    <p className='descTxt modalDescFull'>{shortDesc}</p>
                    {(mrp_in_point && mrp_in_point != 0) &&
                        <p style={{color: "#343434", fontSize: '15px'}}>{`(${prodInfo?.mrpLabel} : ${mrp_in_point})`}</p>
                    }
                    <p className='tdsApplyTxt'>{tdsTxt}</p>

                    <div className="notificationTabList modalTabList">
                        <ul>
                            <li className={isOverview ? 'active' : ''} onClick={() => handleTabClick('overview')}>
                                <Link>Overview</Link>
                            </li>
                            <li className={isSpecification ? 'active' : ''} onClick={() => handleTabClick('specification')}>
                                <Link>Specification</Link>
                            </li>
                        </ul>
                    </div>
                    {isOverview &&
                        <div className='productOverview'>
                            <p className='descTxt modalDescFull'>{loadingDetails ? 'Loading...' : (productDetailsData.short_desc || shortDesc)}</p>
                            <p className='pointsTxt'>{price} <span>Points *</span></p>
                        </div>
                    }
                    {isSpecification &&
                        <div className='specificationView'>
                            <Table striped bordered hover>
                                <tbody>
                                    {productAttributes.length > 0 ? productAttributes.map((item, index) => {
                                        const { attribute_key, attribute_value } = item
                                        return (
                                            <tr key={index}>
                                                <td><b>{attribute_key}</b></td>
                                                <td>{attribute_value}</td>
                                            </tr>
                                        )
                                    }) : (
                                        <tr>
                                            <td>{loadingDetails ? 'Loading...' : 'No specifications available'}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    }
                    <PrimaryGradientButton className='primaryBtn undefined btn btn-primary mt-3' buttonText="Add To Cart"
                        onClick={onClickCart} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SingleProduct